import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { AddMutasiResponse } from "../../constants/types";

type MutasiItemDetail = {
    tipe?: string;
    itemIdAwal?: number;
    itemIdFaktur?: number;
    jumlahKeluar: number;
    itemIdTujuan?: string | number;
    jumlahMasuk: number;
    hargaBeli?: string | number;
    kodeFaktur?: null;
    itemId?: number;
    keterangan: string;
    fakturId?: number;
};

type CreateMutasiItemBody = {
    ukmId?: number;
    detail: MutasiItemDetail[];
};

const createMutasiItem = async (body: CreateMutasiItemBody) => {
    const response = await axios.post<AddMutasiResponse>("/api/mutasiitem", body);
    return response.data;
};

export default function useCreateMutasiItem() {
    const queryClient = useQueryClient();

    return useMutation((body: CreateMutasiItemBody) => createMutasiItem(body), {
        onSuccess: () => {
            queryClient.invalidateQueries(["item"]);
        },
    });
}
